import { differenceInMinutes } from 'date-fns'
import { Trans } from 'react-i18next'

export const getParkingTime = (t, timeStart, timeEnd) => {
  const diffInMinutes = differenceInMinutes(timeEnd, timeStart)
  const hours = Math.floor(diffInMinutes / 60)
  const minutes = diffInMinutes - hours * 60
  return t('parking:parkingTime', { hours, minutes })
}

export const getPayedByResident = (ticketSummary, cost) => {
  if (ticketSummary.paidByResident) {
    return ticketSummary.paidByResident / 100
  }

  return Math.min(ticketSummary.parkingBalance, cost || ticketSummary.cost) / 100
}

export const getPaidByResidentLabel = (ticketSummary) => {
  if (ticketSummary.paidByResident) {
    return (
      <span className="text-primary">
        <Trans
          i18nKey="parking:residentPayment.paidBy"
          values={{ name: ticketSummary.clientName }}
          components={[<strong key="0" />]}
        />
      </span>
    )
  }

  return (
    <span className="text-primary">
      <Trans
        i18nKey="parking:residentPayment.willBePaidBy"
        values={{ name: ticketSummary.clientName }}
        components={[<strong key="0" />]}
      />
    </span>
  )
}
